class GlobalPointerUpListener {
  private static subscribeOrUnsubscribeWindows(window: Window, subscribe: boolean, callback: () => void): void {
    if (subscribe) {
      window.addEventListener('mouseup', callback, { capture: true });
      window.addEventListener('touchend', callback, { capture: true });
    } else {
      window.removeEventListener('mouseup', callback, { capture: true });
      window.removeEventListener('touchend', callback, { capture: true });
    }

    const iframes: HTMLCollectionOf<HTMLIFrameElement> = window.document.getElementsByTagName('iframe');
    for (let i = 0; i < iframes.length; i++) {
      GlobalPointerUpListener.trySubscribeOrUnscribeWindows(iframes[i].contentWindow!, subscribe, callback);
    }
  }

  /**
   * We do a try/except because we may try to add event listeners to iframes that are not from the same source. If
   * that is the case we catch it and continue without adding the listeners.
   */
  private static trySubscribeOrUnscribeWindows(window: Window, subscribe: boolean, callback: () => void): void {
    try {
      GlobalPointerUpListener.subscribeOrUnsubscribeWindows(window, subscribe, callback);
    } catch (e) {
      /**
       * If the document is an iframe from a different source we can't add event listeners.
       * IE, Firefox, and Chrome seem to be throwing different exceptions, so this just assumes
       * that is the error being thrown.
       */
    }
  }

  public static subscribe(callback: () => void): () => void {
    GlobalPointerUpListener.trySubscribeOrUnscribeWindows(window, true, callback);

    return () => {
      GlobalPointerUpListener.trySubscribeOrUnscribeWindows(window, false, callback);
    };
  }
}

export { GlobalPointerUpListener };
